import { DateTime } from 'luxon';

import { convertDateTimeFromUtcToLocal } from '@/utils/convertDateTimeFromUtcToLocal';
import { IStatusTime } from '~/api/IStatusTime';

export interface IResponseProfileTimestamp {
  type: number;
  seconds: number;
  status?: number;
  lateCapture?: number;
}

export interface CheckForRequiredLateReasonsData {
  trip: Record<string, unknown>;
  responseProfileTimestamp?: IResponseProfileTimestamp;
}

const getResponseProfileTypeTimestampKey = (type: number) => [
  { type: 1, prop: 'callDateTime', sub: null },
  { type: 2, prop: 'pickupDateTime', sub: null },
  { type: 3, prop: 'pickupDateTime', sub: null },
  { type: 4, prop: 'statusTimes', sub: { id: '1' } },
  { type: 5, prop: 'statusTimes', sub: { id: '2' } },
  { type: 6, prop: 'statusTimes', sub: { id: '3' } },
  { type: 7, prop: 'statusTimes', sub: { id: '4' } },
  { type: 8, prop: 'statusTimes', sub: { id: '5' } },
  { type: 9, prop: 'statusTimes', sub: { id: '6' } },
  { type: 10, prop: 'appointmentDateTime', sub: null },
  { type: 11, prop: 'callStartedDateTime', sub: null },
].find((item) => item.type === type);

export function checkForRequiredLateReasons(data: CheckForRequiredLateReasonsData): boolean {
  if (!data.responseProfileTimestamp) {
    return false;
  }

  const profile = getResponseProfileTypeTimestampKey(data.responseProfileTimestamp.type);
  if (!profile) {
    return false;
  }

  const now = DateTime.utc();
  let temp = data.trip[profile.prop];

  if (profile.sub) {
    const statusTime = (temp as IStatusTime[]).find((item) => item.status.id === profile.sub?.id);
    temp = statusTime?.timestamp || now.toISO();
  }

  const thenStr = convertDateTimeFromUtcToLocal(String(temp), undefined);
  let then = DateTime.fromISO(String(thenStr));
  if (!then.isValid) then = now;

  const diffSeconds = now.diff(then, 'seconds').seconds || 0;

  if (data.responseProfileTimestamp.type === 2) {
    return diffSeconds > -data.responseProfileTimestamp.seconds;
  }

  return diffSeconds > data.responseProfileTimestamp.seconds;
}
